
import { PropType } from 'vue';
import {DateTimeFilter} from '../../../../src/Entity/Filter/DateTimeFilter';
import {FilterInterface} from '../../../../src/Entity/Filter';
import DatePicker from '@app/vue/DatePicker/index.vue';
import {Value} from '@app/vue/DatePicker/src';
import moment from 'moment';

export default {
    components: {DatePicker},
    props: {
        filter: {
            type: Object as PropType<DateTimeFilter>,
            required: true,
        },
        mode: {
            type: String,
            default: 'active',
        }
    },
    computed: {
        value: {
            set: function(value: Value) {
                return this.filter.value.setDateTimeValue(value);
            },
            get: function() {
                return this.filter.value.getDateTimeValue();
            }
        }
    },
    expose: ['support'],
    methods: {
        support(filter: FilterInterface): boolean {
            return filter instanceof DateTimeFilter;
        },
        remove() {
            this.filter.reset();
        }
    },
    created: function () {
        this.moment = moment;
    },
    data() {
        return {
            showAll: true,
            date: null,
        }
    }
};
